import React from 'react';
import SubjectPage from '../structure/SubjectPage';

const PPL = () => {
  const accordionContent = [
    <div key="1" className="p-4">
      <p>Introduction: Syntax, semantics and pragmatics; Formal translation models, Variables, Expressions &
Statements, Binding time spectrum; Variables and expressions; Assignment; I-values and r-values;
Environments and stores; Storage allocation; Constants and initialization; Statement-level control structure.</p>
    </div>,
    <div key="2" className="p-4">
     <p>Primitive Types: Pointers; Structured types; Coercion; Notion of type equivalence; Polymorphism:
overloading, inheritance, type parameterization, Abstract data types; Information hiding and abstraction;
Visibility, Procedures, Modules, Classes, Packages, Objects and Object-Oriented Programming.</p>
    </div>,
    <div key="3" className="p-4">
      <p>Storage Management: Static and dynamic, stack-based, and heap-based storage management. Sequence
Control: Implicit and explicit sequencing with arithmetic and non-arithmetic expressions; Sequence control
between statements. Subprogram Control: Subprogram sequence control, data control and referencing
environments; parameter passing; static and dynamic scope; block structure.</p>
    </div>,
    <div key="4" className="p-4">
      <p>Concurrent Programming: Concepts, Communication, Deadlocks, Semaphores, Monitors, Threads,
Synchronization. Logic programming: Introduction; Rules, Structured Data and Scope of the variables;
Operators and Functions; Recursion and recursive rules; Lists, Input and Output; Program control; Logic
Program design.</p>
    </div>
  ];

  const tabData = [
    {
      id: 'syllabus',
      label: 'Syllabus',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'notes',
      label: 'Notes',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'important',
      label: 'Important Questions',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'books',
      label: 'Books',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'PYQ',
      label: 'PYQ',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'youtube_playlist',
      label: 'Video Lectures',
      content: null, // Will be replaced in SubjectPage
    },
  ];

  return (
    <SubjectPage
      subjectName="Principles of Programming Languages"
      subjectCode="CIE320"
      subjectKey="PPL" // Unique key for this subject
      accordionContent={accordionContent}
      tabData={tabData}
      adminEmail="snaped4338@gmail.com"
      firestoreCollections={{
        notes: 'PPLNotes',
        videos: 'PPLVideos'
      }}
    />
  );
};

export default PPL;